import { API } from 'aws-amplify';

export const removeUnused = (params = {}) => {
  const outParams = {};
  const isNotObjectArray = index => {
    if (!Array.isArray(params[index])) {
      return false; // Input is not an array
    }

    for (const element of params[index]) {
      if (typeof element === 'object') {
        return false; // Array contains at least one object
      }
    }

    return true; // Input is an array and doesn't contain any objects
  };

  Object.keys(params).forEach(k => {
    if (
      typeof params[k] === 'boolean' ||
      typeof params[k] === 'number' ||
      params[k]
    ) {
      outParams[k] = params[k];
    }
    if (isNotObjectArray(k)) {
      if (Array.isArray(params[k])) {
        outParams[k] = params[k].join(',');
      }
    }
  });
  return outParams;
};

export const apiCall = (
  url,
  method,
  { body, queryString: queryStringParameters, ...others } = {}
) =>
  API[method.toLowerCase()](
    'ApiGatewayChnet',
    url,
    removeUnused({
      response: true,
      body: body || undefined,
      queryStringParameters: queryStringParameters
        ? removeUnused(queryStringParameters)
        : undefined,
      ...others
    })
  );
